import { createContext, useState } from 'react'

export const ReplayCodeContext = createContext()

export const ReplayCodeProvider = ({ children }) => {
  const [code, setCode] = useState("")

  return (
    <ReplayCodeContext.Provider value={{ code, setCode }}>
      {children}
    </ReplayCodeContext.Provider>
  )
}